import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'
const orderReportTypeList = [
  {
    label: '客户订单报备',
    value: '1',
  },
  {
    label: '商品报备',
    value: '2',
  },
] as const

export type OrderReportTypeValue = ValueOf<typeof orderReportTypeList>
export const orderReportTypeEnum = customCreateEnum(orderReportTypeList)
import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'
const orderReportTypeList = [
  {
    label: '客户订单报备',
    value: '1',
  },
  {
    label: '商品报备',
    value: '2',
  },
] as const

export type OrderReportTypeValue = ValueOf<typeof orderReportTypeList>
export const orderReportTypeEnum = customCreateEnum(orderReportTypeList)
